const actionTypes = {
	  FETCH_POSTS_REQUESTED: 'FETCH_POSTS_REQUESTED'
	, FETCH_POSTS_REJECTED: 'FETCH_POSTS_REJECTED'
	, FETCH_POSTS_FULFILLED: 'FETCH_POSTS_FULFILLED'
	, ADD_POST_REQUESTED: 'ADD_POST_REQUESTED'
	, ADD_POST_REJECTED: 'ADD_POST_REJECTED'
	, ADD_POST_FULFILLED: 'ADD_POST_FULFILLED'
	, FETCH_POST_REQUESTED: 'FETCH_POST_REQUESTED'
	, FETCH_POST_REJECTED: 'FETCH_POST_REJECTED'
	, FETCH_POST_FULFILLED: 'FETCH_POST_FULFILLED'
	, UPDATE_POST_REQUESTED: 'UPDATE_POST_REQUESTED'
	, UPDATE_POST_REJECTED: 'UPDATE_POST_REJECTED'
	, UPDATE_POST_FULFILLED: 'UPDATE_POST_FULFILLED'
	, DELETE_POST_REQUESTED: 'DELETE_POST_REQUESTED'
	, DELETE_POST_REJECTED: 'DELETE_POST_REJECTED'
	, DELETE_POST_FULFILLED: 'DELETE_POST_FULFILLED'
	, UPLOAD_FILE_REQUESTED: 'UPLOAD_FILE_REQUESTED'
	, UPLOAD_FILE_REJECTED: 'UPLOAD_FILE_REJECTED'
	, UPLOAD_FILE_FULFILLED: 'UPLOAD_FILE_FULFILLED'
	, UPLOAD_FILE_DISPLAYED: 'UPLOAD_FILE_DISPLAYED'
	, SIGNIN_REQUESTED: 'SIGNIN_REQUESTED'
	, SIGNIN_REJECTED: 'SIGNIN_REJECTED'
	, SIGNIN_FULFILLED: 'SIGNIN_FULFILLED'
	, SIGNOUT_REQUESTED: 'SIGNOUT_REQUESTED'
	, SIGNOUT_REJECTED: 'SIGNOUT_REJECTED'
	, SIGNOUT_FULFILLED: 'SIGNOUT_FULFILLED'
	, TOGGLE_THEME: 'TOGGLE_THEME'
}

export default actionTypes;


// WEBPACK FOOTER //
// ./src/actions/types.js